<template>
<div class="horas">
  <div class="horas__title">{{title}}</div>
  <div class="horas__body">
    <div class="horas__data">
      <div class="horas__number">{{horas}}</div>
      <div class="horas__percent" :class="arrowIndicate">{{percent | toPercent}}</div>
    </div>
    <div class="horas__graph">
      <img :src="img">
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    horas: Number,
    oldHoras: Number,
    tipo: String
  },
  created(){
    switch(this.tipo){
      case 'total':
        this.title = 'Total Horas'
        this.img = require('@/assets/img/bars/barChart3.svg')
        break
      case 'simple':
        this.title = 'Horas Simples'
        this.img = require('@/assets/img/bars/barChart2.svg')
        break
      case  'extra':
        this.title = 'Horas Extras'
        this.img = require('@/assets/img/bars/barChart1.svg')
        break
    }

    this.percent = (this.horas - this.oldHoras)/this.oldHoras * 100
  },
  data() {
    return {
      title: '',
      img: null,
      percent: null
    }
  },

  computed: {
    arrowIndicate(){
      if(this.percent < 0)
        return 'down-indicator'
      else
        return 'up-indicator'
    }
  },

  filters: {
    toPercent(value){
      return `${Math.abs(value).toFixed(2)}%`
    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mqwh($min-width,$max-height){
  @media (min-width: $min-width) and (max-height: $max-height){
    @content;
  }
}

@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

//8-TRUMPS
.down-indicator{
  color: #FF4141;
  &::before{
    content: '\72';
    font-family: 'bluebox';
  }
}
.up-indicator{
  color: #3CC480;
  &::before{
    content: '\76';
    font-family: 'bluebox';
  }
}

.horas{
  width: 21rem;
  height: 7rem;
  background-color: #fff;
  padding: 1rem;
  border-radius: .6rem;
  @include mq('700px'){
    width: 20rem;
  }
  &__body{
    display: flex;
    justify-content: space-between;
  }
  &__title{
    color: rgba($b-blue,.5);
    font-size: .9rem;
  }
  &__number{
    font-weight: 600;
  }
  &__percent{
    display: flex;
    align-items: center;
    font-size: .75em;
  }
}
</style>
